<template lang="pug">
  canvas.triangle(ref="canvas" :width="containWidth" :height="containHeight")
</template>

<script>
  import _ from 'lodash'
  export default {
    name: "triangle",
    props: {
      originalPoints: {
        type: Array,
        default: () => [
          [
            {x: 82, y: 456, arc: 1, range: 10, iterTimes: 100},
            {x: 94, y: 518, arc: 0, range: 10, iterTimes: 200},
            {x: 123, y: 548, arc: 1, range: 10, iterTimes: 300},
          ],
          [
            {x: 120, y: 429, arc: 1, range: 10, iterTimes: 150},
            {x: 150, y: 407, arc: 1, range: 10, iterTimes: 160},
            {x: 145, y: 439, arc: 1.2, range: 10, iterTimes: 180},
          ],
          [
            {x: 950, y: 217, arc: 1, range: 10, iterTimes: 150},
            {x: 1000, y: 260, arc: 1, range: 10, iterTimes: 160},
            {x: 976, y: 288, arc: 1.2, range: 10, iterTimes: 180},
          ],
          [
            {x: 987, y: 180, arc: 1, range: 10, iterTimes: 150},
            {x: 967, y: 160, arc: 1, range: 10, iterTimes: 160},
            {x: 990, y: 209, arc: 1.2, range: 10, iterTimes: 180},
          ],
          [
            {x: 1693, y: 307, arc: 1, range: 10, iterTimes: 150},
            {x: 1764, y: 352, arc: 1, range: 10, iterTimes: 160},
            {x: 1732, y: 350, arc: 0, range: 10, iterTimes: 180},
          ],
          [
            {x: 1827, y: 468, arc: 1, range: 10, iterTimes: 150},
            {x: 1791, y: 473, arc: 0, range: 10, iterTimes: 160},
            {x: 1764, y: 527, arc: 1, range: 10, iterTimes: 180},
          ],
        ],
      }
    },
    data() {
      return {
        ctx: null,
        triangles: this.originalPoints,
        trianglesIterNum: 0,
        target: null,
        targetTrianglesList: this.triangles,
      };
    },
    watch: {},
    computed: {
      containWidth() {
        return window.innerWidth;
      },
      containHeight() {
        return 600;
      },
      iterNum: {
        get() {
          return this.trianglesIterNum;
        },
        set(val) {
          // const maxIterTimes = this.triangles.reduce(
          //   (a, b) => Math.max(
          //     a.reduce((i, j) => Math.max(i.iterTimes, j.iterTimes)),
          //     b.reduce((i, j) => Math.max(i.iterTimes, j.iterTimes))));
          //
          this.trianglesIterNum = val;
          if (0 === this.triangles.reduce((a, b) => Math.max(
            a.reduce((i, j) => Math.max(val % i.iterTimes, val % j.iterTimes)),
            b.reduce((i, j) => Math.max(val % i.iterTimes, val % j.iterTimes)),
          ))) {
            this.trianglesIterNum = 0;
          }
        },
      },
      targetTriangles() {
        const triangles = this.triangles;
        const random = (range) => Math.random() * range - range / 2;
        const targetTriangles = this.targetTrianglesList || _.cloneDeep(triangles);
          for (let i = 0; i < triangles.length; i++) {
            for (let j = 0; j < triangles[i].length; j++) {
              if (this.iterNum % triangles[i][j].iterTimes === 0) {
                const point = triangles[i][j];
                targetTriangles[i].splice(j, 1, {
                  ...point,
                  x: point.x + random(point.range),
                  y: point.y + random(point.range),
                });
              }
            }
          }
          this.targetTrianglesList = targetTriangles;
          return this.targetTrianglesList;
      },
    },
    methods: {
      move() {
        const triangles = this.triangles;
        debugger
        const targets = this.targetTriangles;
        for (let i = 0; i < triangles.length; i++) {
          for (let j = 0; j < triangles[i].length; j++) {
            const point = triangles[i][j];
            const target = targets[i][j];
            point.x += (target.x - point.x) / (point.iterTimes - this.iterNum % point.iterTimes);
            point.y += (target.y - point.y) / (point.iterTimes - this.iterNum % point.iterTimes);
          }
        }
        this.trianglesIterNum++;
      },
      draw() {
        const ctx = this.ctx;
        const triangles = this.triangles;
        ctx.fillStyle = '#2abeff';
        ctx.strokeStyle = '#2abeff';
        for (let i = 0; i < triangles.length; i++) {
          ctx.moveTo(triangles[i][0].x, triangles[i][0].y);
          for (let j = 0; j < triangles[i].length; j++) {
            const point = triangles[i][j];
            const nextPoint = triangles[i][(
              j + 1
            ) % triangles[i].length];
            ctx.beginPath();
            ctx.arc(point.x, point.y, point.arc, 0, Math.PI * 2);
            ctx.fill();
            
            ctx.beginPath();
            ctx.lineTo(nextPoint.x, nextPoint.y);
            ctx.lineTo(point.x, point.y);
            ctx.stroke();
          }
        }
      },
      animation() {
        this.ctx.clearRect(0, 0, this.containWidth, this.containHeight);
        this.move()
        this.draw()
        window.requestAnimationFrame(this.animation);
      },
    },
    created() {
    },
    mounted() {
      const canvas = this.$refs['canvas'];
      this.ctx = canvas.getContext('2d');
      this.animation();
    },
  };
</script>

<style scoped lang="stylus">
  .triangle {
  
  }
</style>
